import './Input.scss';

import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import React from 'react';

const SelectBasicInput = ({ label, value, onChange, name, errors, touched, disabled = false, readOnly = false, options = [] }) => {
    const inputClassName = `custom-input-focus custom-input ${disabled ? 'input-disabled' : ''}`;

    return (
        <>
            <FloatingLabel controlId={name} label={label} className="mb-3 custom-input-label">
                <Form.Select 
                   className={inputClassName}
                    onChange={onChange}
                    readOnly={readOnly}
                    value={value}
                    disabled={disabled}
                    isInvalid={!!errors[name] && touched}
                    aria-label="Floating label select example">
                    {
                        options.map((op) => {
                            return <option value={op.key}>{op.label}</option>
                        })
                    }
                </Form.Select>
                <Form.Control.Feedback style={{ textAlign: 'left' }} type="invalid">
                    {errors[name]}
                </Form.Control.Feedback>

            </FloatingLabel>
        </>
    );
};

export default SelectBasicInput;